import apiClient from './apiClient';

export const getAllServiceData = async () => {
    try {
        // Making GET request to fetch all service data
        const response = await apiClient.get('ServicesRequest/GetAllServicesRequest');
        return response.data; // Returning the list of service data
    } catch (error) {
        console.error('Fetching service data failed:', error.response?.data || error.message);

        // Handling errors during fetching
        if (error.response && error.response.data) {
            throw new Error(error.response.data.message || 'Unknown error occurred while fetching service data');
        } else {
            throw new Error('Network error or unexpected issue while fetching service data');
        }
    }
};
